import defaultModal from '#themes/default/default/components/modal/modal.js';

import cButton from '#themes/default/web/components/button/button.js';
import cCross from '#themes/default/web/components/cross/cross.js';
import cOfferModal from '#themes/default/web/components/offerModal/offerModal.js';
import cPayconiqModal from '#themes/default/web/components/payconiqModal/payconiqModal.js';
import cPaymentFailedModal from '#themes/default/web/components/paymentFailedModal/paymentFailedModal.js';
import cPaymentIframeModal from '#themes/default/web/components/paymentIframeModal/paymentIframeModal.js';

export default {
	components: {
		cButton,
		cCross,
		cOfferModal,
		cPayconiqModal,
		cPaymentFailedModal,
		cPaymentIframeModal
	},
	extends: defaultModal
};
